import { LOGIN_PAGE } from './appRoutes';

/**
 * Public routes configuration
 *
 * This array defines which routes can be accessed without authentication.
 * Patterns support:
 * - Exact matches: '/login'
 * - Wildcards: '/reset-password/*'
 * - Regex patterns: /^\/docs\/.*$/
 *
 * All routes not matched here require authentication.
 */
export const PUBLIC_URLS = [
  LOGIN_PAGE,
  '/forgot-password',
  '/reset-password/*',
  // Add more public routes as needed
];

/**
 * Checks if the given URL path is public (accessible without authentication)
 *
 * @param path - The URL path to check
 * @returns boolean - True if the path is public, false otherwise
 */
export const isPublicUrl = (path: string): boolean => {
  return PUBLIC_URLS.some(pattern => {
    // Exact match
    if (!pattern.includes('*') && !pattern.startsWith('/^')) {
      return pattern === path;
    }

    // Wildcard match (e.g., '/reset-password/*')
    if (pattern.includes('*')) {
      const patternBase = pattern.replace('*', '');
      return path.startsWith(patternBase);
    }

    // Regex pattern match (e.g., /^\/docs\/.*$/)
    if (pattern.startsWith('/^') && pattern.endsWith('$/')) {
      const regex = new RegExp(pattern.slice(1, -1));
      return regex.test(path);
    }

    return false;
  });
};
